import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SystemUpgradeScreenComponent} from './system-upgrade-screen.component';
import {SystemStatusModule} from "../system-status/system-status.module";


@NgModule({
  declarations: [
    SystemUpgradeScreenComponent
  ],
  imports: [
    CommonModule,
    SystemStatusModule,
  ],
  exports: [
    SystemUpgradeScreenComponent
  ],
  providers: []
})
export class SystemUpgradeScreenModule {
}
